<script setup lang="ts">
import { Button } from 'primevue';
import { useTranslations } from '../../translations/composables/useTranslations';

const translations = useTranslations();

defineProps<{
  activeProduct?: string;
  loading?: boolean;
}>();

defineEmits<{
  (e: 'open'): void;
  (e: 'clear'): void;
}>();
</script>

<template>
  <!-- Inactive -->
  <Button
    v-if="!activeProduct"
    icon="pi pi-search"
    :label="translations.products.actions.filterByProduct"
    :loading="loading"
    @click="$emit('open')" />

  <!-- Active -->
  <div v-else class="filter-pill" role="group" :aria-label="`${translations.products.actions.filterByProduct}: ${activeProduct}`">
    <button
      type="button"
      class="filter-pill__main"
      :title="activeProduct"
      @click="$emit('open')">
      <i class="pi pi-filter" />
      <span class="filter-pill__value">{{ activeProduct }}</span>
    </button>
    <button
      type="button"
      class="filter-pill__clear"
      aria-label="Clear filter"
      title="Clear filter"
      @click="$emit('clear')">
      <i class="pi pi-times" />
    </button>
  </div>
</template>

<style scoped>
.filter-pill {
  display: inline-flex;
  align-items: stretch;
  height: 2.5rem;
  border-radius: 999px;
  overflow: hidden;
  background: var(--p-primary-color);
  color: var(--p-primary-contrast-color);
  font-size: 1rem;
  font-weight: 600;
  box-shadow: 0 1px 3px rgb(0 0 0 / 0.3);
}

.filter-pill button {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
  transition: background-color 0.15s;
}

.filter-pill button:hover {
  background: rgb(0 0 0 / 0.15);
}

.filter-pill button:focus-visible {
  outline: 2px solid var(--p-primary-contrast-color);
  outline-offset: -4px;
}

.filter-pill__main {
  padding: 0 0.9rem 0 1.1rem;
  min-width: 0;
}

.filter-pill__value {
  max-width: 14rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filter-pill__clear {
  justify-content: center;
  width: 2.75rem;
  padding: 0;
  border-left: 1px solid rgb(255 255 255 / 0.3) !important;
}
</style>
